module.exports = __webpack_public_path__ + "static/media/print-header-background.7cb3658c.jpg";